module.exports = "<div id=\"divLoading\" [class.hidden]=\"!show\">\n  <p *ngIf=\"show\">\n    <img src=\"assets/loader.gif\">\n  </p>\n</div>"